import React from 'react';
import { Dropdown, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const Menu3Dot = ({ items, className }) => {
  const menu = {
    items: items.map(({ key, label, onClick, disabled }) => ({
      key,
      label,
      onClick,
      disabled,
    })),
  };

  return (
    <Dropdown className={className} menu={menu} trigger={['click']}>
      <Button
        icon={<MoreOutlined style={{ width: '20px', height: '20px', borderRadius: '10x' }} />}
        type="text"
      />
    </Dropdown>
  );
};

export default Menu3Dot;
